import { Marina } from './marina';
import { MenuItem } from './menu-item';

export class Role {
  public id: number;
  public name: string;
  public marina: Marina;
  public menuItens: MenuItem[];
  public hierarchy: number;
  public photos: boolean;
  public administrator: boolean;
  public responsible: boolean;
  public changeInvoiceDates: boolean;
  public docMaster: boolean;
  /** EAS-327 — perfil-padrão do sistema (EAS-267); só vem com o EAS-327 ligado no backend. */
  public systemDefault?: boolean;
  public code?: string;
  constructor(id?) {
    this.id = id;
    this.menuItens = [];
    this.photos = false;
  }
}
